import React from "react";

import i18next from "i18next";
import english from "./i18n/english";
import spanish from "./i18n/spanish";
import korean from "./i18n/korean";
import ParentConsentFormAddPage from "./parentConsentFormAdd";

i18next.addResourceBundle("en", "JobApplication", english);
i18next.addResourceBundle("es", "JobApplication", spanish);
i18next.addResourceBundle("kr", "JobApplication", korean);

export const ParentConsentFormParentViewRoutes = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: "parent-consent-form/:userId",
      element: <ParentConsentFormAddPage isParent={true} isAdmin={false} />,
    },
  ],
};
